/**
 * Shared HTTP header utilities used by the auth Axios client and the OAuth
 * error-handler interceptor.
 */

export const setAuthorizationHeader = (
  config: { headers?: unknown },
  token: string,
): void => {
  config.headers = {
    ...(config.headers as Record<string, string> | undefined),
    Authorization: `Bearer ${token}`,
  };
};
